import { SpecialAttackSkill, StatusSkill } from "../../core/skill";
import { ConsumeEffect, Effect, RoundEffect } from "../../core/effect";
import { Timing } from "../../core/timing";

import * as type from "../../core/type";
import * as cond from "../../core/cond";
import * as effect from "../../core/effect";
import * as state from "../../core/state";
import * as pred from "../../core/pred";

/** 业火红莲：焚烬施加失败时通过未触发谓词改为施加睡眠。 */
export const 业火红莲 = new SpecialAttackSkill(
    "业火红莲",
    type.飞行·火,
    [
        "消除对手的回合类效果，消除成功则50%令对手焚烬，未触发则100%令对手睡眠",
        "3回合内，每回合有80%的几率闪避对手的攻击",
    ],
    80,
    [
        new Effect(new effect.消除回合(), Timing.onDamage, undefined, [
            new Effect(
                new effect.施加异常状态(new state.焚烬()),
                Timing.triggered,
                cond.百分之x的几率(50),
                [
                    new Effect(
                        new effect.施加异常状态(new state.睡眠()),
                        Timing.untriggered,
                    ),
                ],
            ),
        ]),
    ],
    3,
    false,
    1,
    5,
);

export const 永生之池 = new StatusSkill(
    "永生之池",
    [
        "免疫下1次受到的攻击",
        "为自身附加400点护盾，护盾被击破时80%令对手焚烬",
        "消除双方所有的能力提升、能力下降和回合类效果，然后双方同时进入烧伤状态，持续3回合",
    ],
    [
        new ConsumeEffect(
            Timing.onSkillHit,
            1,
            new effect.免疫攻击(),
            Timing.beforeSkillHit,
            undefined,
            false,
            [],
        ),
    ],
);

export const 九霄凤鸣 = new StatusSkill(
    "九霄凤鸣",
    [
        "全属性+1，体力高于1/2时强化效果翻倍",
        "4回合内，每回合吸取对手最大的1/3，体力低于1/2时吸取效果翻倍",
        "3回合内，若对手使用攻击技能则焚烬，使用属性技能则其下2回合无法使用攻击技能",
    ],
    [
        new Effect(
            new effect.强化(1, cond.若自身体力高于x分之一(2)),
            Timing.onSkillHit,
        ),
        new RoundEffect(
            Timing.onSkillHit,
            4,
            new effect.吸取体力(({ sbjPet }) => Math.round(sbjPet.最大体力 * (1 / 3)), undefined, undefined, cond.若自身体力低于x分之一(2)),
            Timing.actionEnd,
            undefined,
            false,
            [],
        ),
    ],
);

export const 青鸾炽羽阵 = new SpecialAttackSkill(
    "青鸾炽羽阵",
    type.飞行·火,
    [
        "无视对手免疫伤害效果",
        "3回合内，免疫并反弹异常状态",
        "80%令对手焚烬，未触发则降低对手最大体力的1/3",
    ],
    150,
    [
        new Effect(
            new effect.无视攻击免疫(),
            Timing.beforeSkillHit,
        ),
        new RoundEffect(
            Timing.onSkillHit,
            3,
            new effect.免疫异常状态(),
            Timing.beforeSkillHit,
            undefined,
            false,
            [],
        ),
        new Effect(
            new effect.施加异常状态(new state.焚烬()),
            Timing.onDamage,
            cond.百分之x的几率(80),
            [
                new Effect(
                    new effect.固伤(pred.对手最大体力的x分之一(3)),
                    Timing.untriggered,
                ),
            ],
        )
    ],
    1,
    false,
    1,
    5,
);

export const 凤仪九州城 = new SpecialAttackSkill(
    "凤仪九州城",
    type.飞行·火,
    [
        "自身处于能力下降状态时先制+2",
        "反转自身的能力下降状态，反转成功则附加400点固定伤害",
        "对手处于能力提升状态时先制+2",
        "消除对手的能力提升状态，消除成功则对手速度-2、命中-2，且下1回合先制-2",
    ],
    160,
    [new Effect(new effect.消除强化(), Timing.onDamage)],
    0,
    true,
    1,
    5,
);
